import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { newsApi } from '../services/api';

export default function NewsDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    newsApi.get(id)
      .then(data => setArticle(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{ paddingTop: 120, textAlign: 'center', color: '#8C7A6A', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div>
        <div style={{ fontSize: 36, marginBottom: 12, animation: 'spin 1s linear infinite' }}>⏳</div>
        <p style={{ fontFamily: 'Space Mono, monospace', fontSize: 13 }}>Chargement...</p>
        <style>{`@keyframes spin { from { transform: rotate(0) } to { transform: rotate(360deg) } }`}</style>
      </div>
    </div>
  );

  if (notFound || !article) return (
    <div style={{ paddingTop: 120, textAlign: 'center', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📰</div>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Article introuvable</h2>
        <Link to="/" className="btn-primary" style={{ display: 'inline-block' }}>← Retour à l'accueil</Link>
      </div>
    </div>
  );

  const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/watch?v=')) return url.replace('watch?v=', 'embed/').split('&')[0];
    if (url.includes('youtu.be/')) return `https://www.youtube.com/embed/${url.split('youtu.be/')[1].split('?')[0]}`;
    if (url.includes('vimeo.com/') && !url.includes('player.vimeo.com')) return `https://player.vimeo.com/video/${url.split('vimeo.com/')[1].split('?')[0]}`;
    return url;
  };

  return (
    <div style={{ paddingTop: 'var(--nav-h, 64px)', background: '#F5F0E8', minHeight: '100vh' }}>

      {/* Hero */}
      {article.coverImage && (
        <div style={{ height: 420, position: 'relative', overflow: 'hidden', background: '#1A1208' }}>
          <img
            src={article.coverImage}
            alt={article.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.7 }}
          />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(26,18,8,0.1) 0%, rgba(26,18,8,0.8) 100%)' }} />
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 'clamp(20px,5vw,40px)' }}>
            <div style={{ maxWidth: 800, margin: '0 auto' }}>
              {article.isPinned && (
                <span style={{ display: 'inline-block', background: 'var(--radar-orange)', color: '#fff', fontSize: 10, fontFamily: 'Space Mono, monospace', letterSpacing: '0.1em', padding: '3px 10px', borderRadius: 2, marginBottom: 14 }}>
                  📌 ÉPINGLÉ
                </span>
              )}
              <h1 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 700, color: '#fff', letterSpacing: '-0.02em', lineHeight: 1.15, marginBottom: 16, textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}>
                {article.title}
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'Space Mono, monospace', fontSize: 12 }}>
                {article.authorName || 'RADAR'} · {new Date(article.createdAt).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: article.coverImage ? 'clamp(24px,5vw,48px) var(--px,clamp(16px,5vw,40px))' : 'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px)) clamp(24px,5vw,48px)' }}>

        {/* Back link */}
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#8C7A6A', fontFamily: 'Space Mono, monospace', fontSize: 12, marginBottom: 32, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
          ← Retour à l'accueil
        </Link>

        {/* Title if no cover image */}
        {!article.coverImage && (
          <div style={{ marginBottom: 40 }}>
            {article.isPinned && (
              <span style={{ display: 'inline-block', background: 'var(--radar-accent3, #FFF3E0)', color: 'var(--radar-orange)', fontSize: 10, fontFamily: 'Space Mono, monospace', letterSpacing: '0.1em', padding: '3px 10px', borderRadius: 2, marginBottom: 14 }}>
                📌 ÉPINGLÉ
              </span>
            )}
            <h1 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.15, marginBottom: 14 }}>
              {article.title}
            </h1>
            <p style={{ color: '#8C7A6A', fontFamily: 'Space Mono, monospace', fontSize: 12 }}>
              {article.authorName || 'RADAR'} · {new Date(article.createdAt).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
        )}

        {/* Excerpt callout */}
        {article.excerpt && (
          <div style={{ padding: '20px 24px', background: '#fff', borderLeft: '4px solid var(--radar-orange)', borderRadius: '0 6px 6px 0', marginBottom: 36 }}>
            <p style={{ fontSize: 18, color: '#3A2810', lineHeight: 1.6, fontStyle: 'italic' }}>{article.excerpt}</p>
          </div>
        )}

        {/* Rich text content */}
        <div
          style={{ fontSize: 17, lineHeight: 1.8, color: '#2A1E12' }}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />

        {/* Video embed */}
        {article.videoUrl && (
          <div style={{ marginTop: 40 }}>
            <p style={{ fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#8C7A6A', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 16 }}>Vidéo</p>
            <div style={{ borderRadius: 8, overflow: 'hidden', aspectRatio: '16/9', background: '#1A1208' }}>
              <iframe
                src={getEmbedUrl(article.videoUrl)}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={article.title}
              />
            </div>
          </div>
        )}

        {/* Footer */}
        <div style={{ marginTop: 60, paddingTop: 32, borderTop: '1px solid rgba(140,122,106,0.2)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: 13, color: '#8C7A6A' }}>
            Publié par <strong>{article.authorName || 'RADAR'}</strong> le {new Date(article.createdAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
          <button onClick={() => navigate(-1)} style={{ padding: '10px 20px', background: 'none', border: '1px solid rgba(140,122,106,0.3)', borderRadius: 4, cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#8C7A6A', letterSpacing: '0.05em' }}>
            ← Retour
          </button>
        </div>
      </div>

      {/* Article content styles */}
      <style>{`
        .article-content h1, .article-content h2 { font-size: 26px; font-weight: 700; margin: 36px 0 14px; letter-spacing: -0.01em; color: #1A1208; }
        .article-content h3 { font-size: 20px; font-weight: 700; margin: 28px 0 10px; color: #1A1208; }
        .article-content p { margin-bottom: 20px; }
        .article-content ul, .article-content ol { padding-left: 24px; margin-bottom: 20px; }
        .article-content li { margin-bottom: 6px; }
        .article-content a { color: var(--radar-orange); text-decoration: underline; }
        .article-content blockquote { border-left: 4px solid var(--radar-orange); padding: 16px 20px; background: #fff; margin: 28px 0; font-style: italic; color: #5A4A3C; border-radius: 0 6px 6px 0; }
        .article-content strong { color: #1A1208; }
        .article-content img { max-width: 100%; border-radius: 6px; margin: 20px 0; }
      `}</style>
    </div>
  );
}
